import React, { useState } from 'react';
import { resolveStockIconUrl, buildDefaultStockIconUrl } from 'utils/stockLogoUtils';

function StockSearchLogo({ item }) {
    const [src, setSrc] = useState(
        () => resolveStockIconUrl(item) || buildDefaultStockIconUrl()
    );

    const handleError = () => {
        const defaultUrl = buildDefaultStockIconUrl();
        if (src !== defaultUrl) {
            setSrc(defaultUrl);
        }
    };

    return (
        <img
            className="symbol-search-logo avatar-sm"
            src={src}
            alt=""
            onError={handleError}
        />
    );
}

export default function ListStockSelect({ list = [], loading = false, onClickSelected }) {
    if (!loading && (!list || list.length === 0)) {
        return (
            <div className="symbol-search-dropdown symbol-search-dropdown--empty">
                No se encontraron resultados
            </div>
        );
    }

    return (
        <div className="symbol-search-dropdown" role="listbox">
            {loading && (
                <div className="symbol-search-dropdown-status">Buscando...</div>
            )}
            {!loading && (
                <ul className="symbol-search-list">
                    {list.filter(Boolean).map((item) => (
                        <li key={item.id || item.symbol}>
                            <button
                                type="button"
                                className="symbol-search-item"
                                onClick={() => onClickSelected(item)}
                            >
                                <StockSearchLogo item={item} />
                                <div className="symbol-search-meta">
                                    <span className="symbol-search-symbol">{item.symbol}</span>
                                    <span className="symbol-search-name">{item?.name || item?.symbol}</span>
                                </div>
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
